export default __webpack_public_path__ + "static/media/play.e1aa4284.png";